import { createContext } from 'react';

const NhlStatsContext = createContext({
  // isFetching: false,
  data: {},
});

export default NhlStatsContext;
